import styled from 'styled-components'

import { WHITE, DARKYELLOW } from '../../../../../../styles/colors.style'

export const ContainerLimit = styled.section`
	width: 95%;

	.box-limit {
		display: flex;
		justify-content: space-between;
		padding-bottom: 5px;

		&:last-child {
			border-bottom: 1px solid rgba(255, 255, 255, 0.25);
			margin-bottom: 10px;
		}

		p {
			margin: 0;
			color: ${WHITE};
			font: 15px/19px 'Source Sans Pro';
		}
	}

	.box-range {
		background: rgba(255, 255, 255, 0.67);
		width: 100%;
		height: 9px;
		border-radius: 10px;
		margin-bottom: 10px;
		overflow: hidden;

		.range {
			background: ${DARKYELLOW};
			height: 100%;
		}
	}
`
